var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"px-7 py-3 d-flex justify-center text-align"},[_vm._v(" "+_vm._s(_vm.message)+" ")]),_c('div',{staticClass:"px-7 pb-0 d-flex justify-center"},[_c('span',{staticClass:"text-heading mb-5"},[_vm._v(" "+_vm._s(_vm.confirmMessage)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }